import Home from './pages/HomePage';
import Login from './pages/LoginPage';
import CategoriesAdmin from './pages/CategoriesAdmin';
import AdminHomePage from './pages/AdminHomePage';
import TestsAdmin from './pages/TestsAdmin';
import PackagesAdmin from './pages/PackagesAdmin';
import NewsAdmin from './pages/NewsAdmin';
//import AppointmentAdmin from './pages/AppointmentAdmin';
import ResultsAdmin from './pages/ResultsAdmin';
import InquiriesAdmin from './pages/InquiriesAdmin';
import AboutUsPage from './pages/AboutUsPage';
import AboutUsAdmin from './pages/AboutUsAdmin';
//import AppointmentReqPage from './pages/AppointmentReqPage';
import Tests from './pages/Tests';
import MapTest from './pages/MapTest';
import ManageAdmins from './pages/ManageAdmins';
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom';
import {auth, database} from './config/firebaseConfig';
import {doc, getDoc} from 'firebase/firestore'
import {onAuthStateChanged} from 'firebase/auth';
import { useCallback, useState } from 'react';
import ScrollToTop from './components/ScrollToTop';
import MyProfile from './pages/MyProfile';
import Register from './pages/RegisterPage';
import {AnimatePresence} from 'framer-motion';
import Layout from './components/Layout';
import CampaignsAdmin from './pages/CampaignsAdmin';
import News from './pages/News';
import ServicesPage from './pages/ServicesPage';
import 'react-loading-skeleton/dist/skeleton.css';
import React, {useContext} from 'react';
import { UserContext } from './context/UserContext';
import Error404 from './pages/Error404';

function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState('');
  const [isLoading, setIsLoading] = useState(true);


  onAuthStateChanged(auth, useCallback(async (userLogged) => {
    if (userLogged) {
      const userRef = doc(database, `users/${userLogged.uid}`);
      
      try {
        if (!role) {
          const userData = await getDoc(userRef);
          setRole(userData.data().role);
          setIsLoading(false);
          setUser({...userData.data(), id:userData.id});
        }
        
      }catch(e){
        console.log(e.message);
      }
      
    } else {
      setUser(null);
    }
    setIsLoading(false);
  }, [role]));

  function isAdmin() {
    
    if ( role === 'superAdmin' || role === 'admin' ) {
      return true

    } else {
      return false
    }
  }

  return (
    <div>
      <UserContext.Provider value = {{user}}>
        { isLoading
        ?
        <div className="flex w-screen h-screen justify-center items-center">
          <div className="flex items-center justify-center ">
              <div className="w-40 h-40 border-t-4 border-b-4 border-primary-100 rounded-full animate-spin"></div>
          </div>
        </div>
        :
        <BrowserRouter>
          <ScrollToTop />
          <AnimatePresence>
            <Routes>
              <Route path='/' element={<Layout />}>
                {!user? <Route path="/" element={<Home />} /> : isAdmin() === true ? <Route path="/" element={<AdminHomePage />} /> : <Route path="/" element={<Home />} />}
                <Route path="/Login" element={!user? <Login /> : true && <Navigate to="/" replace />} />
                <Route path="/Register" element={!user? <Register /> : true && <Navigate to="/" replace />} />
                <Route path="/CategoriesAdmin" element={<CategoriesAdmin />} />
                {/*<Route path="/AppointmentAdmin" element={<AppointmentAdmin />} />*/}
                <Route path="/TestsAdmin" element={<TestsAdmin />} />
                <Route path="/PackagesAdmin" element={<PackagesAdmin />} />
                <Route path="/NewsAdmin" element={<NewsAdmin />} />
                <Route path="/ResultsAdmin" element={<ResultsAdmin />} />
                <Route path="/InquiriesAdmin" element={<InquiriesAdmin/>}/>
                <Route path="/MyProfile" element={<MyProfile/>}/>
                <Route path="/CampaignsAdmin" element={<CampaignsAdmin />}/>
                <Route path="/News" element={<News />}/>
                <Route path="/Services" element={<ServicesPage />}/>
                <Route path="/AboutUs" element={<AboutUsPage />}/>
                <Route path="/AboutUsAdmin" element={<AboutUsAdmin />}/>
                {/*<Route path="/AppointmentRequest" element={<AppointmentReqPage />}/>*/}
                <Route path="/Tests" element={<Tests />}/>
                <Route path="/MapTest" element={<MapTest />}/>
                <Route path="/ManageAdmins" element={<ManageAdmins />}/>
                <Route path="*" element={<Error404 />} />
              </Route>
            </Routes>
          </AnimatePresence>
        </BrowserRouter>
        }
      </UserContext.Provider>
    </div>
  );
}

export default App;
export const UserAuth = () => {
  return useContext(UserContext);
}